/**
 * Standard authenticated layout: TopBar across the top, LeftRail on
 * the left, page content in the middle.
 *
 * Pages render inside `<main>`; they should provide their own padding
 * if anything beyond the default `p-6` is needed.
 *
 * `aside` — необязательная правая панель уровня оболочки (`patterns.md
 * §Боковая панель у реестра`). Она сестра `<main>`, а не его потомок: только так
 * панель занимает всю высоту рабочей области и скроллится независимо от
 * содержимого страницы. Модальности нет — контент слева остаётся видимым и
 * кликабельным.
 */
import { TopBar } from "@/layout/TopBar";
import { LeftRail } from "@/layout/LeftRail";

interface AppShellProps {
  children: React.ReactNode;
  aside?: React.ReactNode;
}

export function AppShell({ children, aside }: AppShellProps): React.ReactElement {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <TopBar />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <LeftRail />
        <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto p-6">{children}</main>
        {aside}
      </div>
    </div>
  );
}
